import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { isMobile } from "react-device-detect";

import { destroyHomePin } from "actions/home.action";

import ConditionWrapper from "components/ConditionWrapper";

const PostHomePin = ({ authority, post, viewType, location = '', created = false }) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	
	// 핀 고정 해제
	const handleDestroyPin = (event) => {
		event.preventDefault();

		if ((post.board_type !== 105 && !authority.is_pin_cancelable) || (post.board_type === 105 && !authority.is_vod_pin_cancelable)) {
			return;
		}
		
		dispatch(destroyHomePin(post.title_no, post.board_type, location, created));
	};
	
	const { pin = null } = post;

	if (!pin || (pin && !pin.is_pin)) {
		return null;
	}
	
	let boardTypeName = "";
	if(post.pin.board_type == 105){
		boardTypeName = t("VOD");
	} else {
		boardTypeName = t("게시글");
	}

	return (
		<button
			type="button"
			className={`${ isMobile ? 'btn-pin' : 'pin'}`}
			tip=
			{
				// 게시글 리스트형 툴팁 노출 X
				viewType != 1 ?
				post.pin.from_reducer ? t("고정해제") :
				// BJ
				post.pin.is_owner ? 
					post.pin.worker_id == null || post.pin.bj_id == post.pin.worker_id ? t("고정해제") : t("{{managerNick}}이/가 고정한 {{boardTypeName}}입니다.", { managerNick : post.pin.worker_nick, boardTypeName : boardTypeName })
				// 매니져
				: post.pin.is_manager ? 
					post.pin.worker_id == null || post.pin.bj_id == post.pin.worker_id ? t("스트리머가 고정한 {{boardTypeName}}입니다.", { boardTypeName : boardTypeName }) :
						post.pin.login_id == post.pin.worker_id ? t("고정해제") : t("{{managerNick}}이/가 고정한 {{boardTypeName}}입니다.", { managerNick : post.pin.worker_nick, boardTypeName : boardTypeName })
				// 비로그인 또는 일반유저
				: post.pin.worker_id == null || post.pin.bj_id == post.pin.worker_id ? t("스트리머가 고정한 {{boardTypeName}}입니다.", { boardTypeName : boardTypeName }) : t("{{managerNick}}이/가 고정한 {{boardTypeName}}입니다.", { managerNick : post.pin.worker_nick, boardTypeName : boardTypeName })
				: null
			}
			tip2=
			{
				// 게시글 리스트형 툴팁 노출 X
				viewType != 1 ?
				post.pin.from_reducer ? null :
				// BJ
				post.pin.is_owner ? 
					post.pin.worker_id == null || post.pin.bj_id == post.pin.worker_id ? null : t("(클릭하여 고정 해제)")
				// 매니져
				: post.pin.is_manager ? 
					post.pin.worker_id == null || post.pin.bj_id == post.pin.worker_id ? t("(클릭하여 고정 해제)") : 
						post.pin.login_id == post.pin.worker_id ? null : t("(클릭하여 고정 해제)")
				// 비로그인 또는 일반유저
				: null 
				: null
			}
			onClick={handleDestroyPin}
		>
			<ConditionWrapper condition={!isMobile} wrapper="span">
				<Trans>고정해제</Trans>
			</ConditionWrapper>
		</button>
	);
};

export default PostHomePin;
